import IconCheckFieldHeader from "./IconCheckFieldHeader";


export const HEADER_COMPONENTS = {
    IconCheckFieldHeader,
};